<div style="padding: 16px">
  @if (!valittuSetti) {
    <div>
      <div class="info-block">
        <p class="info-block__title">Testisetit kategorialle "{{ kategoria }}"</p>
        <p style="margin: 0; font-size: 12px">Testisetti on kokoelma testitapauksia (kirjauksia). Testisetti voi sisältää vain saman kategorian testitapauksia.</p>
      </div>

      <!-- Uusi setti -->
      <div style="display: flex; gap: 8px; align-items: flex-end; margin-bottom: 16px">
        <mat-form-field style="flex: 1">
          <mat-label>Uuden testisetin nimi</mat-label>
          <input matInput [formField]="uusiSettiNimiKentta" />
        </mat-form-field>
        <app-primary-button (click)="luoSetti.emit()" [disabled]="luoSettiKaynnissa || !uusiSettiNimi.trim()" actionId="Luo LLM-testisetti">
          @if (luoSettiKaynnissa) {
            <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          Luo setti
        </app-primary-button>
      </div>

      @if (setitLataa) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      @if (!setitLataa && !setit.length) {
        <p style="color: #888">Ei vielä settejä — luo ensimmäinen yllä.</p>
      }

      @if (!setitLataa && setit.length) {
        <div style="max-height: 420px; overflow-y: auto">
        <table style="width: 100%; font-size: 13px; border-collapse: collapse">
          <tr style="background: #f5f5f5">
            <th style="text-align: left; padding: 6px; position: sticky; top: 0; background: #f5f5f5">Nimi</th>
            <th style="text-align: right; padding: 6px; position: sticky; top: 0; background: #f5f5f5">Testitapauksia</th>
            <th style="padding: 6px; position: sticky; top: 0; background: #f5f5f5"></th>
          </tr>
          @for (s of setit; track s.avain) {
            <tr style="border-bottom: 1px solid #eee">
              <td style="padding: 6px">
                <app-button (click)="avaaSetti.emit(s)" styles="padding-left: 0" actionId="Avaa LLM-testisetti">
                  <strong>{{ s.nimi }}</strong>
                </app-button>
              </td>
              <td style="padding: 6px; text-align: right">{{ s.testitapausLkm }}</td>
              <td style="padding: 6px">
                <app-icon-button (click)="poistaSetti.emit(s)" matIcon="delete" matTooltip="Poista" actionId="Poista LLM-testisetti"></app-icon-button>
              </td>
            </tr>
          }
        </table>
        </div>
      }
    </div>
  }

  @if (valittuSetti) {
    <div>
      <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px">
        <app-icon-button (click)="suljeSetti.emit()" matIcon="arrow_back" matTooltip="Takaisin" actionId="Sulje LLM-testisetti"></app-icon-button>
        <h3 style="margin: 0">{{ valittuSetti.nimi }}</h3>
      </div>

      <div style="display: flex; gap: 16px; align-items: flex-start">
        <div #tositeContainer style="flex: 0 0 45%; max-width: 45%; height: calc(100vh - 220px); overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain; border: 1px solid #eee; border-radius: 8px; padding: 8px; position: sticky; top: 8px">
          @if (!valittuTestitapaus()) {
            <div style="color: #888; text-align: center; padding-top: 40px">Valitse kirjaus nähdäksesi sen tositteen</div>
          } @else if (naytettavatTositteetJaSivut() === null) {
            <mat-spinner diameter="24" style="margin: 40px auto"></mat-spinner>
          } @else if (!naytettavatTositteetJaSivut().length) {
            <div style="color: #888; text-align: center; padding-top: 40px">Kirjaukseen ei ole liitetty tositetta</div>
          } @else {
            <div app-kirjanpito-tosite-naytto [piilotaYlaControllit]="true" [naytaRuksi]="false" [scrollContainerRef]="tositeContainerRef" [naytettavaKirjausObservable]="tyhjaKirjausObservable" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut()"></div>
          }
        </div>

        <div style="flex: 1 1 auto; min-width: 0">
          <h4 style="margin: 0 0 8px; font-size: 13px">Setissä olevat testitapaukset ({{ settiTestitapaukset.length }})</h4>
          <div style="max-height: calc(100vh - 260px); overflow-y: auto; overscroll-behavior: contain">
          @if (settiTestitapauksetLataa) {
            <mat-spinner diameter="24"></mat-spinner>
          }
          @if (!settiTestitapauksetLataa && !settiTestitapaukset.length) {
            <p style="color: #888">Ei vielä testitapauksia — lisää alta.</p>
          }
          @for (rivi of settiTestitapaukset; track rivi.avain) {
            <div class="kl" [class.valittu]="valittuTestitapaus()?.avain === rivi.avain" style="max-width: 700px; cursor: pointer" (click)="valitseTestitapaus(rivi)">
              <div class="kirj-info">
                <a [routerLink]="['/asiakkaat', rivi.asiakasAvain, 'kirjanpito', kirjanpitoVuosi(rivi.kirjaus.p), kirjanpitoKuukausi(rivi.kirjaus.p), 'tositteet']" class="dark-gray-text pkn pnc" style="margin-right: 30px">{{ rivi.kirjaus.kirjausnumero }}</a>
                <div class="dark-gray-text" style="font-size: 90%">{{ formatPvm(rivi.kirjaus.p) }} — {{ rivi.asiakasNimi }}</div>
                @if (rivi.kirjaus.kirjauksenSumma !== null && rivi.kirjaus.kirjauksenSumma !== undefined) {
                  <div class="kirj-sum" [class.red-text]="rivi.kirjaus.kirjauksenSumma < 0" [class.green-text]="rivi.kirjaus.kirjauksenSumma > 0">{{ rivi.kirjaus.kirjauksenSumma | number: '1.2-2' }} €</div>
                }
                @if (rivi.kirjaus.kirjauksenSaajaTaiMaksaja) {
                  <div class="tstm">{{ rivi.kirjaus.kirjauksenSaajaTaiMaksaja }}</div>
                }
                @if (rivi.kirjaus.kirjauksenSaajaTaiMaksajaIban) {
                  <div style="padding-top: 1px">{{ rivi.kirjaus.kirjauksenSaajaTaiMaksajaIban }}</div>
                }
                @if (rivi.kirjaus.kirjauksenViitenumero) {
                  <div style="padding-top: 7px">Viitenumero: {{ rivi.kirjaus.kirjauksenViitenumero }}</div>
                }
                @if (rivi.maksutapaNimi) {
                  <div style="padding-top: 4px">Maksutapa: {{ rivi.maksutapaNimi }}</div>
                }
                @if (rivi.kirjaus.kirjauksenLemonaidViesti) {
                  <div style="padding-top: 7px">Asiakkaan kommentti: {{ rivi.kirjaus.kirjauksenLemonaidViesti }}</div>
                }
              </div>
              <div style="margin-right: 48px">
                <app-icon-button (click)="$event.stopPropagation(); poistaJasenyys.emit(rivi)" [disabled]="poistetaanJasenyys.has(rivi.avain)" matTooltip="Poista setistä" style="position: absolute; top: 4px; right: 0" actionId="Poista testitapaus setistä">
                  @if (poistetaanJasenyys.has(rivi.avain)) {
                    <mat-spinner diameter="18"></mat-spinner>
                  } @else {
                    <mat-icon>delete</mat-icon>
                  }
                </app-icon-button>

                <!-- Jaettu editori (ensisijainen vastaus, olemassaoleva vaihtoehto tai uusi vaihtoehto) -->
                <ng-template #editori>
                  @if (tilikarttaLataa()) {
                    <mat-spinner diameter="20" style="margin: 8px 0"></mat-spinner>
                  } @else if (muokattavaKirjaus()) {
                    @for (kr of muokattavaKirjaus().rivit; track kr.av) {
                      @if (onAlvRivi(kr)) {
                        <div class="kr lukittu" [attr.data-arvoavain]="kr.av">
                          <div class="knc lukittu">
                            <div class="kn">{{ kr.t }}</div>
                            <div class="knr">{{ annaTilinNimi(kr.t) }}</div>
                          </div>
                          <div class="kd lukittu">{{ kr.d > 0 ? (kr.d | number: '1.2-2') : '' }}</div>
                          <div class="kk lukittu">{{ kr.k > 0 ? (kr.k | number: '1.2-2') : '' }}</div>
                          <div class="ka lukittu">{{ annaAlvLyhenne(kr) }}</div>
                        </div>
                      } @else {
                        <div class="kr" [attr.data-arvoavain]="kr.av">
                          <div class="knc" tabindex="0">
                            <div class="kn">{{ kr.t }}</div>
                            <div class="knr">{{ annaTilinNimi(kr.t) }}</div>
                          </div>
                          <div class="kd" tabindex="0">{{ kr.d > 0 ? (kr.d | number: '1.2-2') : '' }}</div>
                          <div class="kk" tabindex="0">{{ kr.k > 0 ? (kr.k | number: '1.2-2') : '' }}</div>
                          <div class="ka" tabindex="0">{{ annaAlvLyhenne(kr) }}</div>
                        </div>
                      }
                    }
                    <div class="krj dark-gray-text">
                      <div class="kna"></div>
                      <div class="kda" [class.red-text]="!muokkausTasapainossa()">{{ debetYhteensa(muokattavaKirjaus().rivit) | number: '1.2-2' }}</div>
                      <div class="kka" [class.red-text]="!muokkausTasapainossa()">{{ kreditYhteensa(muokattavaKirjaus().rivit) | number: '1.2-2' }}</div>
                      <div class="kaa"></div>
                    </div>
                    <div style="display: flex; gap: 8px; align-items: center; margin-top: 8px" (click)="$event.stopPropagation()">
                      @if (!muokkausTasapainossa()) {
                        <div class="red-text" style="font-size: 12px">Debet ja kredit eivät täsmää</div>
                      }
                      <span style="flex: 1"></span>
                      <app-secondary-button (click)="peruutaMuokkaus()" [disabled]="tallennetaan()" actionId="Peruuta kirjauksen muokkaus">Peruuta</app-secondary-button>
                      <app-primary-button (click)="tallennaMuokkaus()" [disabled]="tallennetaan() || !muutoksia() || !muokkausTasapainossa()" actionId="Tallenna kirjauksen muokkaus">
                        @if (tallennetaan()) {
                          <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
                        }
                        {{ tallennaPainikeTeksti }}
                      </app-primary-button>
                    </div>
                  }
                </ng-template>

                <!-- Hyväksyttyjen vastausten otsikko + uuden vaihtoehdon lisäys -->
                <div style="display: flex; align-items: center; gap: 8px; margin-top: 12px; margin-bottom: 6px" (click)="$event.stopPropagation()">
                  <div class="dark-gray-text" style="font-size: 12px; font-weight: 600">Hyväksytyt kirjaukset ({{ 1 + (rivi.oikeatVaihtoehdot?.length ?? 0) }})</div>
                  <span style="flex: 1"></span>
                  <app-button (click)="aloitaUusiVaihtoehto(rivi)" [disabled]="tallennetaan()" actionId="Lisää oikea vaihtoehto">+ Lisää vaihtoehto</app-button>
                </div>

                <!-- Vastaus #1: ensisijainen (pää-kirjaus) -->
                <div class="vastaus-kortti" [class.muokattava]="onkoPaaMuokattavana(rivi)">
                  <div class="dark-gray-text" style="font-size: 11px; font-weight: 600; min-height: 28px; display: flex; align-items: center" (click)="$event.stopPropagation()">Ensisijainen kirjaus</div>
                  <div class="kra dark-gray-text">
                    <div class="kna">Tili</div>
                    <div class="kda">Debet</div>
                    <div class="kka">Kredit</div>
                    <div class="kaa">Alv</div>
                  </div>
                  @if (onkoPaaMuokattavana(rivi)) {
                    <ng-container [ngTemplateOutlet]="editori"></ng-container>
                  } @else {
                    @for (kirjausrivi of rivi.kirjaus.rivit; track $index) {
                      <div class="kr" [class.lukittu]="onAlvRivi(kirjausrivi)">
                        <div class="knc" [class.lukittu]="onAlvRivi(kirjausrivi)" (click)="$event.stopPropagation(); aloitaMuokkausSolusta(rivi, kirjausrivi, 'tili')" [style.cursor]="onAlvRivi(kirjausrivi) ? 'default' : 'text'">
                          <div class="kn">{{ kirjausrivi.t }}</div>
                          <div class="knr">{{ annaTilinNimi(kirjausrivi.t, rivi.asiakasAvain) }}</div>
                        </div>
                        <div class="kd" [class.lukittu]="onAlvRivi(kirjausrivi)" (click)="$event.stopPropagation(); aloitaMuokkausSolusta(rivi, kirjausrivi, 'debet')" [style.cursor]="onAlvRivi(kirjausrivi) ? 'default' : 'text'">{{ kirjausrivi.d > 0 ? (kirjausrivi.d | number: '1.2-2') : '' }}</div>
                        <div class="kk" [class.lukittu]="onAlvRivi(kirjausrivi)" (click)="$event.stopPropagation(); aloitaMuokkausSolusta(rivi, kirjausrivi, 'kredit')" [style.cursor]="onAlvRivi(kirjausrivi) ? 'default' : 'text'">{{ kirjausrivi.k > 0 ? (kirjausrivi.k | number: '1.2-2') : '' }}</div>
                        <div class="ka" [class.lukittu]="onAlvRivi(kirjausrivi)" (click)="$event.stopPropagation(); aloitaMuokkausSolusta(rivi, kirjausrivi, 'alv')" [style.cursor]="onAlvRivi(kirjausrivi) ? 'default' : 'text'">{{ annaAlvLyhenne(kirjausrivi) }}</div>
                      </div>
                    }
                    <div class="krj dark-gray-text">
                      <div class="kna"></div>
                      <div class="kda">{{ debetYhteensa(rivi.kirjaus.rivit) | number: '1.2-2' }}</div>
                      <div class="kka">{{ kreditYhteensa(rivi.kirjaus.rivit) | number: '1.2-2' }}</div>
                      <div class="kaa"></div>
                    </div>
                  }
                </div>

                <!-- Vastaukset #2..N: muut hyväksytyt vaihtoehdot -->
                @for (vaihtoehto of rivi.oikeatVaihtoehdot; track vaihtoehto.avain) {
                  <div class="vastaus-kortti" [class.muokattava]="onkoVaihtoehtoMuokattavana(rivi, vaihtoehto.avain)">
                    <div style="display: flex; align-items: center; gap: 6px; min-height: 28px" (click)="$event.stopPropagation()">
                      <span class="dark-gray-text" style="font-size: 11px; font-weight: 600">Vaihtoehto {{ $index + 2 }}</span>
                      <span style="flex: 1"></span>
                      @if (!onkoVaihtoehtoMuokattavana(rivi, vaihtoehto.avain)) {
                        <app-icon-button (click)="poistaVaihtoehto(rivi, vaihtoehto, $index + 2)" matIcon="delete" matTooltip="Poista" actionId="Poista oikea vaihtoehto"></app-icon-button>
                      }
                    </div>
                    <div class="kra dark-gray-text">
                      <div class="kna">Tili</div>
                      <div class="kda">Debet</div>
                      <div class="kka">Kredit</div>
                      <div class="kaa">Alv</div>
                    </div>
                    @if (onkoVaihtoehtoMuokattavana(rivi, vaihtoehto.avain)) {
                      <ng-container [ngTemplateOutlet]="editori"></ng-container>
                    } @else {
                      @for (kr of vaihtoehto.rivit; track $index) {
                        <div class="kr" [class.lukittu]="onAlvRivi(kr)">
                          <div class="knc" [class.lukittu]="onAlvRivi(kr)" (click)="$event.stopPropagation(); aloitaVaihtoehtoMuokkausSolusta(rivi, vaihtoehto, kr, 'tili')" [style.cursor]="onAlvRivi(kr) ? 'default' : 'text'">
                            <div class="kn">{{ kr.t }}</div>
                            <div class="knr">{{ annaTilinNimi(kr.t, rivi.asiakasAvain) }}</div>
                          </div>
                          <div class="kd" [class.lukittu]="onAlvRivi(kr)" (click)="$event.stopPropagation(); aloitaVaihtoehtoMuokkausSolusta(rivi, vaihtoehto, kr, 'debet')" [style.cursor]="onAlvRivi(kr) ? 'default' : 'text'">{{ kr.d > 0 ? (kr.d | number: '1.2-2') : '' }}</div>
                          <div class="kk" [class.lukittu]="onAlvRivi(kr)" (click)="$event.stopPropagation(); aloitaVaihtoehtoMuokkausSolusta(rivi, vaihtoehto, kr, 'kredit')" [style.cursor]="onAlvRivi(kr) ? 'default' : 'text'">{{ kr.k > 0 ? (kr.k | number: '1.2-2') : '' }}</div>
                          <div class="ka" [class.lukittu]="onAlvRivi(kr)" (click)="$event.stopPropagation(); aloitaVaihtoehtoMuokkausSolusta(rivi, vaihtoehto, kr, 'alv')" [style.cursor]="onAlvRivi(kr) ? 'default' : 'text'">{{ annaAlvLyhenne(kr) }}</div>
                        </div>
                      }
                      <div class="krj dark-gray-text">
                        <div class="kna"></div>
                        <div class="kda">{{ debetYhteensa(vaihtoehto.rivit) | number: '1.2-2' }}</div>
                        <div class="kka">{{ kreditYhteensa(vaihtoehto.rivit) | number: '1.2-2' }}</div>
                        <div class="kaa"></div>
                      </div>
                    }
                  </div>
                }

                <!-- Uuden vaihtoehdon editori (näkyy vain luotaessa) -->
                @if (onkoMuokattavana(rivi) && muokattavaOnUusiVaihtoehto()) {
                  <div class="vastaus-kortti muokattava">
                    <div class="dark-gray-text" style="font-size: 11px; font-weight: 600; min-height: 28px; display: flex; align-items: center">Uusi vaihtoehto</div>
                    <div class="kra dark-gray-text">
                      <div class="kna">Tili</div>
                      <div class="kda">Debet</div>
                      <div class="kka">Kredit</div>
                      <div class="kaa">Alv</div>
                    </div>
                    <ng-container [ngTemplateOutlet]="editori"></ng-container>
                  </div>
                }
              </div>
            </div>
          }
          </div>
        </div>
      </div>

      <div class="hidden-inputs-for-form">
        <form style="visibility: hidden; position: absolute; left: -9999px">
          <input #tnroInput type="text" class="kni" style="width: 100%" autocomplete="off" data-lpignore="true" [matAutocomplete]="tiliAuto" />
          <input #debetInput type="text" class="kdi" style="width: 80px" autocomplete="off" data-lpignore="true" />
          <input #kreditInput type="text" class="kki" style="width: 80px" autocomplete="off" data-lpignore="true" />
          <input #alvInput type="text" class="kai" style="width: 60px" autocomplete="off" data-lpignore="true" [matAutocomplete]="alvAuto" />
        </form>
        <mat-autocomplete #tiliAuto="matAutocomplete" panelWidth="360px" (optionSelected)="tiliValittiin($event)">
          @for (t of suodatetutTilitObservable | async; track t.numero) {
            <mat-option [value]="t.numero" style="font-size: 12px">{{ t.numero }} {{ annaTilinNimi(t.numero) }}</mat-option>
          }
        </mat-autocomplete>
        <mat-autocomplete #alvAuto="matAutocomplete" panelWidth="360px" (optionSelected)="alvValittiin($event)">
          @for (a of suodatetutAlvtObservable | async; track a.tunniste) {
            <mat-option [value]="a.lyhenne" style="font-size: 12px">{{ a.lyhenne }} — {{ a.nimi }}</mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>
  }
</div>
